"use client"

import { useEffect, useState } from "react"
import { createPortal } from "react-dom"
import Link from "next/link"
import { Menu, X } from "lucide-react"
import type { NavLink } from "./types"

type Props = {
  navLinks?: NavLink[]
  hideSignIn?: boolean
}

export function MobileMenu({ navLinks, hideSignIn = false }: Props) {
  const [open, setOpen] = useState(false)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    if (open) {
      const prev = document.body.style.overflow
      document.body.style.overflow = "hidden"
      return () => {
        document.body.style.overflow = prev
      }
    }
  }, [open])

  const overlay = open ? (
    <div className="fixed inset-0 z-[100] bg-[#0A0F1F]">
      <div className="flex items-center justify-between border-b border-white/10 px-6 py-3">
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-white/60">Menu</span>
        <button
          type="button"
          aria-label="Close menu"
          onClick={() => setOpen(false)}
          className="flex h-9 w-9 items-center justify-center rounded-md text-white transition hover:bg-white/10"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
      <nav className="flex flex-col gap-1 px-6 py-6">
        {navLinks?.map((link) => (
          <Link
            key={link.href}
            href={link.href}
            onClick={() => setOpen(false)}
            className="rounded-md px-3 py-3 text-base text-white/80 transition hover:bg-white/5 hover:text-white"
          >
            {link.label}
          </Link>
        ))}
        {!hideSignIn && (
          <Link
            href="/login"
            onClick={() => setOpen(false)}
            className="rounded-md px-3 py-3 text-base text-white/80 transition hover:bg-white/5 hover:text-white"
          >
            Sign in
          </Link>
        )}
      </nav>
    </div>
  ) : null

  return (
    <div className="sm:hidden">
      <button
        type="button"
        aria-label="Open menu"
        aria-expanded={open}
        onClick={() => setOpen(true)}
        className="flex h-9 w-9 items-center justify-center rounded-md text-white transition hover:bg-white/10"
      >
        <Menu className="h-5 w-5" />
      </button>
      {mounted && overlay ? createPortal(overlay, document.body) : null}
    </div>
  )
}
